import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { SiteLayoutComponent, SiteSection } from "shared/components/site-layout";
import { LoadingComponent } from "shared/components/loading";
import { usePageMeta } from "shared/mechanics/page-meta";
import { prerenderMarkLoaded } from "shared/mechanics/prerender";

import {EtfService, IEtfAssetBackend, IEtfBackend} from "api/etf";

import {EtfPageParams as EtfPageRouteParams, EtfPageSection} from "../model";
import {PageWithSettingsComponent} from "../../../shared/components/page-with-settings";
import {EtfPageSettingsTitle} from "../shared/settings-title";
import {EtfPageSettingsContent} from "../shared/settings-content";
import {EtfDocumentsPageContent} from "../documents/components/content";
import {EtfAssetsPageContent} from "./components/content";


export const EtfAssetsPage = () => {
	const params = useParams<EtfPageRouteParams>();
	const [etfInfo, setEtfInfo] = useState<IEtfBackend | null>(null);
	const [assets, setAssets] = useState<IEtfAssetBackend[] | null>(null);
	const [isDataTruncated, setIsDataTruncated] = useState<boolean>(false);

	useEffect(
		() => { EtfService.info(params.ticker).then(setEtfInfo); },
		[]);
	useEffect(
		() => { 
			EtfService.assets(params.ticker)
				.then(result => { 
					setAssets(result.data);
					setIsDataTruncated(result.isDataTruncated); 
				});
		},
		[]);

	usePageMeta({
		title: etfInfo == null
			? 'Загрузка данных'
			: `${etfInfo.ticker} полный состав активов`,
		description: etfInfo == null
			? ''
			: `Полная структура ценных бумаг в БПИФ {Ticker} ${etfInfo.ticker}`,
		keyWords: etfInfo == null
			? []
			: ['строение', 'акции', 'структура', 'композиция', 'assets', 'категории'],
		canonicalPath: `etf/${params.ticker}/comparison`
	});
	
	if (etfInfo == null || assets == null)
		return (
			<SiteLayoutComponent activeSection={SiteSection.None}>
				<LoadingComponent />
			</SiteLayoutComponent>
		);

	prerenderMarkLoaded();

	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			<PageWithSettingsComponent
				defaultIsSettingsExpanded={true}
				settingsTitleChild={props => <EtfPageSettingsTitle {...props} ticker={etfInfo.ticker} shortDescription={etfInfo.shortDescription} />}
				settingsContentChild={<EtfPageSettingsContent section={EtfPageSection.ASSETS} etf={etfInfo} />}
				settingCompactModeShowButtonText={etfInfo.ticker}
				contentChild={<EtfAssetsPageContent ticker={etfInfo.ticker} assets={assets} isDataTruncated={isDataTruncated} />} />
		</SiteLayoutComponent>
	)	
};